import { Container, Row, Col } from "react-bootstrap";
import Thinking_AI from "../../../images/AI_thinking.png";
import welcome_ai from "../../../images/Welcome_ai.png";
import ai_analysis from "../../../images/Emotion_analysis.png";

export default function StudyOneInstructionPageTwo(){
        const googleDriveVideoIds = ["1bgzhB8vlHl4i3oKNQgf6ohiX8ecQ1Nid",

    ];
    return (
        <Container className="study-item">
            <h1 style={{ fontWeight: 'bold'}}>Be Emotion spies with EmoAI !</h1>
            <br /><br />
            <Row>
                <Row className="align-items-start mb-4">
                        <Col xs={4} className="text-center">
                            <img 
                                src={welcome_ai} 
                                alt="FEAI icon" 
                                style={{ width: "150px", height: "150px", }} 
                            />
                        </Col>
                        <Col xs={6}>
                        <div className="chat-bubble">
                            <p>
                            Let's see how people’s emotions change.
                            </p>
                        </div>
                        </Col>
                </Row> 
                <Container style={{width:"90%"}}>
                    <Row>
                        <p>People believe that smiles can spread happiness. Coca-Cola launched the “Choose Happiness” 
                            campaign in Belgium. Gonzales organized a local flash mob event.  </p>
                    </Row>

                    <Row>
                        <h1 className="subtitle">Happines starts with a smile!</h1>
                            {googleDriveVideoIds.map((videoId, index) => (
                                <Col  className="text-center mb-4 video-wrapper">
                                    <iframe
                                        src={`https://drive.google.com/file/d/${videoId}/preview`}
                                        allow="autoplay"
                                        className="video-iframe"
                                        style={{ width: "100%", height: "auto" }}
                                    ></iframe>
                                </Col>
                            ))}
                        </Row>



                </Container>
            </Row>
        </Container>
    );
};